module.exports = __webpack_public_path__ + "static/media/ct-logo.df3180ab.png";